import { ObjectShare } from "@reporting/rp-types/core";

/**
 * The keys a form list holds: the one key of a single-choice list, or the serialized selection of a
 * multiple-choice one (`[key, level, state, ...]` per node). Nothing chosen gives an empty array.
 */
export function listKeys(value: unknown): (string|number)[] {
	if (value == null || value === '') return [];
	if (!Array.isArray(value)) return [value as string|number];
	return value
		.map(item => (Array.isArray(item) ? item[0] : item) as string|number)
		.filter(key => key != null && key !== '');
}

/**
 * One registration per combination of a chosen object and a chosen target company - the form
 * registers "3 reports for 8 companies" in one go. Modules without an object choice (ETL, MDM) pass
 * no objects and get one registration per company.
 */
export function combineSyncObjects(objects: (string|number)[]|null, accountings: (string|number)[], common: ObjectShare = {}): ObjectShare[] {
	const rows: ObjectShare[] = [];
	for (const object of objects ?? [null]) {
		for (const accounting of accountings) {
			rows.push({
				...common,
				...(object === null ? {} : { id_object: String(object) }),
				accounting_share: Number(accounting),
			});
		}
	}
	return rows;
}
